import { Collapse, Tabs, Spin } from 'antd';
import { useEffect, useState } from 'react';
import CounterParty from './Model/CounterParty';
import EsignStatus from './Model/EsignStatus';
import axiosInstance from '../../utils/axiosInstance';
import { useTheme } from '../../utils/themeToggle/theme';

const { TabPane } = Tabs;

const EsignAccordion = ({ id }) => {
  const [activeKey, setActiveKey] = useState("1");
  const [isLoading, setIsLoading] = useState(false);
  const [signuluResponse, setSignuluResponse] = useState({});
  const { darkMode } = useTheme();

  const handleEsignStatus = async () => {
    setIsLoading(true);
    try {
      const response = await axiosInstance.post(`/esign/esign_document_status/`, { agreement_id: id });
      if (response?.data) {
        const tempResponse = response.data;
        const recipients = tempResponse.recipients.map((recipient) => ({
          fullName: recipient.FullName,
          email: recipient.EmailAddress,
          signatureImage: recipient.SignatureUpload,
          status: recipient.StatusCode,
        }));
        setSignuluResponse({
          recepients: recipients,
          addComments: tempResponse.addComments,
          senderName: tempResponse.senderName,
          statusCode: tempResponse.statusCode,
          expirationDate: tempResponse.expirationDate,
          fileName: tempResponse.uploadDocuments[0]?.FileName,
        });
      }
    } catch (error) {
      console.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    handleEsignStatus();
  }, []);

  const tabStyle = {
    padding: '20px',
    borderRadius: '10px',
    backgroundColor: darkMode ? '#17153B' : '#fff',
    color: darkMode ? '#fff' : '#000',
    minHeight: '200px',
    border: darkMode ? '.3px solid #4b5563' : '1px solid #ddd',
    // boxShadow: darkMode
    //   ? '0 0 10px rgba(255, 255, 255, 0.05)'
    //   : '0 0 10px rgba(0, 0, 0, 0.05)',
  };

  return (
    <div >
      <Tabs
        activeKey={activeKey}
        onChange={(key) => setActiveKey(key)}
        tabBarGutter={20}
        tabBarStyle={{
          marginBottom: '1rem',
          backgroundColor: darkMode ? '#17153B' : '#fff',
          padding: '0rem 1rem',
          borderRadius: '10px',
        }}
      >
        <TabPane
          tab={<span style={{ fontSize: '16px', fontWeight: '500' }}>View E-sign Status</span>}
          key="1"
        >
          <div style={tabStyle}>
            {isLoading ? (
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                height: '200px',
                gap: '10px',
                color: darkMode ? '#ccc' : '#666'
              }}>
                <div>Loading E-sign Status...</div>
                <Spin spinning={isLoading} />
              </div>
            ) : (
              <EsignStatus signuluResponse={signuluResponse} id={id} />
            )}
          </div>
        </TabPane>

        <TabPane
          tab={<span style={{ fontSize: '16px', fontWeight: '500' }}>Send to Counter Party</span>}
          key="2"
        >
          <div style={tabStyle}>
            <CounterParty onClose={() => setActiveKey(null)} id={id} />
          </div>
        </TabPane>
      </Tabs>
    </div>
  );
};

export default EsignAccordion;
